import React, { useState } from "react";
import { MailCheck } from "lucide-react";
import { Button } from "./ui/button";
import { resendVerification, errText } from "../lib/teamInvites";

/** Shown to new password accounts until they follow the emailed link (runs and payments need it). */
export default function VerifyEmailBanner({ user, onToast }) {
  const [busy, setBusy] = useState(false);
  if (!user || user.email_verified !== false) return null;
  const resend = async () => {
    setBusy(true);
    try {
      const r = await resendVerification();
      onToast?.(r.already_verified ? "Your email is already verified."
        : r.sent ? `We sent a new link to ${user.email}.`
        : r.reason === "email_not_configured" ? "We couldn't send the email: email isn't set up on our side yet. Please contact info@headkeysoftwaresolution.com."
        : "We couldn't send the email right now. Please try again later.");
    } catch (e) {
      onToast?.(errText(e, "Couldn't send the email. Please try again later."));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="verify-email-banner" className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3">
      <p className="flex items-center gap-2 text-sm text-amber-900">
        <MailCheck className="h-4 w-4" />
        Confirm your email ({user.email}) to run the agent, buy a plan or invite people. Check your inbox for the link.
      </p>
      <Button size="sm" variant="outline" disabled={busy} onClick={resend} data-testid="verify-email-resend">
        Resend link
      </Button>
    </div>
  );
}
